import React, { useState, useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import Button from '../../components/Button/Button';
import ProductSelect from '../Select/ProductSelect';
import ProductAddForm from '../Product/ProductAddForm';
import AssetAddForm from '../Asset/AssetAddForm';
import AssetCommentList from '../Asset/AssetCommentList';
import AssetAddCommentForm from '../Asset/AssetAddCommentForm';
import Product from '../Product/EmbeddedProduct';
import { useProducts, useDecoratedAsset, useFiles } from '../../services/Firestore/Resources';
import FilesAddForm from '../Files/FilesAddForm';
import FilesList from '../Files/FilesList';
import Pane from '../../components/Tab/Pane/Pane';
import Tab from '../../components/Tab/Tab';
import { useFlash } from '../../components/Flash/Flash';
import { useCurrentUser } from '../../services/AuthContext/AuthContext';

const useStyles = createUseStyles({
  root: {
    minHeight: 600,
    minWidth: 800,
  },
});

const ManifestCreateNewAssetForm = ({ onClose, onAddToManifest }) => {
  const [products, productsLoading] = useProducts();

  const [assetCreatedId, setAssetCreatedId] = useState(null);
  const [files, filesLoading] = useFiles({
    where: [{ field: 'parent', op: '==', value: assetCreatedId }],
  });
  const [newAsset] = useDecoratedAsset(assetCreatedId);
  const classes = useStyles();
  const [productSelected, setProductSelected] = useState(null);
  const [showHeaders, setShowHeaders] = useState(true);
  const [productId, setProductId] = useState(null);

  const user = useCurrentUser();

  const flash = useFlash();
  const tab = useRef(null);

  useEffect(() => {
    if (!products || !productId) return;
    const product = products.find((obj) => obj.id === productId);
    if (!product) {
      return;
    }
    setProductSelected(product);
  }, [products, productId]);

  const handleCreatedProduct = (productId) => {
    setProductId(productId);
    flash.notification(`Model has been created`);
    tab.current.setSelected(0);
  };

  const handleSubmitAsset = function (newAssetId) {
    setShowHeaders(false);
    setAssetCreatedId(newAssetId);
  };

  const addAssetToManifest = function (asset) {
    setShowHeaders(true);
    setAssetCreatedId(null);
    setProductId(null);
    onAddToManifest(productSelected, asset);
    onClose && onClose();
  };

  if (productsLoading || filesLoading) return 'Loading...';

  return (
    <div className={classes.root}>
      {showHeaders && (
        <>
          <h1>Creating a new asset</h1>
          <Tab stretchTabs ref={tab}>
            <Pane title={<h2>Make asset from existing model</h2>}>
              <ProductSelect
                value={productId}
                required
                onChange={({ value }) => setProductId(value)}
              />
              {/*https://trello.com/c/PThB9sbp/312-productselect-returnerer-id-by-default-la-den-returnere-hele-produktet*/}
              {productId && (
                <>
                  <Product product={productSelected} />
                  <div>
                    <h3>Please provide asset information</h3>
                    <AssetAddForm
                      productId={productId}
                      storageId={user.home}
                      onSubmit={handleSubmitAsset}
                    />
                  </div>
                </>
              )}
            </Pane>
            <Pane title={<h2>Create a new model</h2>}>
              <ProductAddForm onSubmit={handleCreatedProduct} />
            </Pane>
          </Tab>
        </>
      )}
      {assetCreatedId && newAsset && (
        <>
          <h1>Asset {newAsset.product?.name} now created</h1>
          <p>Do you want to add comments or files?</p>
          <div>
            <div>
              <p>
                <strong>Comments:</strong>
              </p>
              <AssetCommentList asset={newAsset} user={user} />
              <AssetAddCommentForm assetId={assetCreatedId} />
            </div>
            <div>
              <p>
                <strong>Upload files:</strong>
              </p>
              {files.length > 0 && (
                <FilesList files={files.filter((f) => f.parent === assetCreatedId)} />
              )}
              <FilesAddForm parent={assetCreatedId} />
            </div>
          </div>
          <hr />
          <Button type='button' onClick={() => addAssetToManifest(newAsset)}>
            Add asset to manifest
          </Button>
        </>
      )}
    </div>
  );
};

export default ManifestCreateNewAssetForm;
